import { useState, type FormEvent } from "react";
import { post } from "../api";
import { Notice, StudentShell } from "../components/Layout";

function fragment() {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const value = { token: params.get("token") || "", studentId: params.get("student") || "" };
  if (value.token) history.replaceState(null, "", window.location.pathname);
  return value;
}
export function UnsubscribePage() {
  const [value] = useState(fragment); const [done, setDone] = useState(false); const [error, setError] = useState("");
  async function submit(event: FormEvent) {
    event.preventDefault();
    try { await post("/api/unsubscribe", value); setDone(true); } catch (reason) { setError(reason instanceof Error ? reason.message : "Could not update preference"); }
  }
  return <StudentShell title="Email reminders"><section className="student-card">
    {error && <Notice kind="error">{error}</Notice>}
    {done ? <><Notice kind="success">Class-pass reminder emails have been switched off.</Notice><a className="secondary-link" href="/me">Back to records</a></>
      : <form onSubmit={submit} className="stack-form"><p>Stop future class-pass balance and expiry reminder emails?</p>
        <button className="primary-button" disabled={!value.token || !value.studentId}>Stop reminders</button></form>}
  </section></StudentShell>;
}